import { ExamLocationManagementHeader } from '@exam-center/exam-location-management';
import { Box } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ExamLocationManagementLayout() {
  return (
    <>
      <ExamLocationManagementHeader />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <Outlet />
      </Box>
    </>
  );
}
